import React, { useState } from "react";
import TopNav from "./TopNav";
import Sidebar from "./SideBar";

export default function Layout({ children, title }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Main Content Wrapper */}
      <div
        className={`flex-1 flex flex-col transition-all duration-300`}
        style={{ marginLeft: sidebarOpen ? "16rem" : "5rem" }} // 16rem = w-64, 5rem = w-20
      >
        {/* Top Navigation */}
        <div
          className="fixed top-0 right-0 left-0 h-16 z-10 transition-all duration-300"
          style={{ left: sidebarOpen ? "16rem" : "5rem" }}
        >
          <TopNav title={title} />
        </div>

        {/* Scrollable Content */}
        <main className="flex-1 overflow-y-auto mt-16 p-6 bg-gray-50">
          {children}
        </main>
      </div>
    </div>
  );
}
